/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.loadingToggle)();
	  (0, _module.anchorLink)();
	  (0, _module.mvSlider)();
	  (0, _module.toggleMenu)();
	  (0, _module.projectToggle)();
	  (0, _module.moviePlay)();
	  (0, _module.scrollAnim)();
	  (0, _module.loadAnim)();
	  (0, _module.scrollPetal)();
	  (0, _module.toggleSidedeco)(); // toggleParallax();
	
	  (0, _module.fallingRose)();
	  (0, _module.randomChara)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.randomChara = exports.fallingRose = exports.toggleParallax = exports.toggleSidedeco = exports.scrollPetal = exports.loadAnim = exports.scrollAnim = exports.loadingToggle = exports.moviePlay = exports.projectToggle = exports.toggleMenu = exports.mvSlider = exports.anchorLink = void 0;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	exports.anchorLink = anchorLink;
	
	function videoControl(action, target) {
	  var $playerWindow = $(target)[0].contentWindow;
	  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
	} // ------------------------------------------------------------------------
	// moviePlay
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var moviePlay = function moviePlay() {
	  $(window).on("load ", function () {
	    videoControl("playVideo", '#youtube-player');
	  });
	  $('.idx-Movie .youtube-toggle').on('click', function () {
	    $(".idx-Modal").toggleClass("open");
	    $(".st-Header .hamburger button").toggleClass("open").toggleClass("youtube");
	    videoControl("playVideo", '#youtube-modal');
	  });
	}; // ------------------------------------------------------------------------
	// toggleMenu
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.moviePlay = moviePlay;
	
	var toggleMenu = function toggleMenu() {
	  $('.st-Header .hamburger button, .st-Header .item-anchor').on('click', function () {
	    if ($(this).hasClass('youtube')) {
	      $(".idx-Modal").toggleClass("open");
	      $(".st-Header .hamburger button").toggleClass("open").toggleClass("youtube");
	      videoControl("pauseVideo", '#youtube-modal');
	    } else {
	      $(".st-Header .hamburger button").toggleClass("open");
	      $(".st-Header nav").toggleClass("open");
	    }
	  });
	}; // ------------------------------------------------------------------------
	// mvSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleMenu = toggleMenu;
	
	var mvSlider = function mvSlider() {
	  $(window).on("load ", function () {
	    var _$$slick;
	
	    $('.slider-mv').slick((_$$slick = {
	      autoplay: true,
	      arrows: true,
	      dots: true,
	      infinite: false,
	      speed: 500,
	      autoplaySpeed: 5000,
	      fade: true
	    }, _defineProperty(_$$slick, "infinite", true), _defineProperty(_$$slick, "cssEase", 'ease'), _defineProperty(_$$slick, "prevArrow", '<button class="slick-prev slick-arrow"></button>'), _defineProperty(_$$slick, "nextArrow", '<button class="slick-next slick-arrow"></button>'), _defineProperty(_$$slick, "customPaging", function customPaging(slick, index) {
	      var targetImage = slick.$slides.eq(index).attr('data-src');
	      return '<button style="background:url(' + targetImage + ') no-repeat center center/contain"/>';
	    }), _$$slick));
	  });
	}; // ------------------------------------------------------------------------
	// projectToggle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.mvSlider = mvSlider;
	
	var projectToggle = function projectToggle() {
	  var projectHeight = $(".idx-Projects").outerHeight() + windowHeight / 2;
	  var p01Height = $("#project-01").outerHeight();
	  var p02Height = $("#project-02").outerHeight();
	  var p03Height = $("#project-03").outerHeight();
	  var p04Height = $("#project-04").outerHeight();
	  var controller = new ScrollMagic.Controller();
	  new ScrollMagic.Scene({
	    triggerElement: "#projects",
	    duration: projectHeight
	  }).setClassToggle(".idx-Projects_Nav", "visible") // add class toggle
	  .addTo(controller);
	  new ScrollMagic.Scene({
	    triggerElement: "#project-01",
	    duration: p01Height
	  }).setClassToggle(".item-01", "current") // add class toggle
	  .addTo(controller);
	  new ScrollMagic.Scene({
	    triggerElement: "#project-02",
	    duration: p02Height
	  }).setClassToggle(".item-02", "current") // add class toggle
	  .addTo(controller);
	  new ScrollMagic.Scene({
	    triggerElement: "#project-03",
	    duration: p03Height
	  }).setClassToggle(".item-03", "current") // add class toggle
	  .addTo(controller);
	  new ScrollMagic.Scene({
	    triggerElement: "#project-04",
	    duration: p04Height
	  }).setClassToggle(".item-04", "current") // add class toggle
	  .addTo(controller);
	}; // ------------------------------------------------------------------------
	// toggleParallax
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.projectToggle = projectToggle;
	
	var toggleParallax = function toggleParallax() {
	  if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document) {} else {
	    var rellax = new Rellax('.prlx', {
	      breakpoints: [576, 768, 1201]
	    });
	  }
	}; // ------------------------------------------------------------------------
	// loadingToggle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleParallax = toggleParallax;
	
	var loadingToggle = function loadingToggle() {
	  $('.st-Loading').height(windowHeight);
	  $(window).on('load', function () {
	    $('.st-Container').css('visibility', 'visible');
	    $('.st-Loading').toggleClass('exit');
	    $('.idx-Mainvisual').toggleClass('visible');
	    setTimeout(function () {
	      $('.st-Loading').css('display', 'none');
	    }, 600);
	    setTimeout(function () {
	      $('.idx-Mainvisual').toggleClass('visible');
	    }, 3000);
	  });
	}; // ------------------------------------------------------------------------
	// scrollAnim
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.loadingToggle = loadingToggle;
	
	var scrollAnim = function scrollAnim() {
	  $(window).on('scroll load', function () {
	    $('.js-sc').each(function () {
	      var targetPos = $(this).offset().top;
	      var scrollPos = $(window).scrollTop();
	      var windowHeight = $(window).height();
	
	      if (scrollPos > targetPos - windowHeight + windowHeight / 6) {
	        $(this).addClass("animated");
	      }
	    });
	  });
	}; // ------------------------------------------------------------------------
	// loadAnim
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.scrollAnim = scrollAnim;
	
	var loadAnim = function loadAnim() {
	  $(window).on('load', function () {
	    $('.js-ld').each(function () {
	      var target = $(this);
	      $(this).addClass("animated");
	    });
	  });
	}; // ------------------------------------------------------------------------
	// scrollPetal
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.loadAnim = loadAnim;
	
	var scrollPetal = function scrollPetal() {
	  if (navigator.platform == "MacIntel" && navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {} else {
	    if (navigator.userAgent.indexOf('iPad') > 0) {} else {
	      $(window).on('scroll', function () {
	        var scrollTop = $(window).scrollTop();
	        var bgPositionFast = scrollTop / 5;
	        var bgPositionSlow = scrollTop / 15;
	
	        if (bgPositionFast) {
	          $("#style").html('.st-Sidedeco span.left:before{background-position: center top -' + bgPositionFast + 'px; } .st-Sidedeco span.left:after{background-position: center top -' + bgPositionSlow + 'px; } .st-Sidedeco span.right:before{background-position: center top -' + bgPositionFast + 'px; } .st-Sidedeco span.right:after{background-position: center top -' + bgPositionSlow + 'px; }');
	        }
	      });
	    }
	  }
	}; // ------------------------------------------------------------------------
	// toggleSidedeco
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.scrollPetal = scrollPetal;
	
	var toggleSidedeco = function toggleSidedeco() {
	  if ($(".st-Sidedeco").hasClass('lower')) {
	    $(".st-Sidedeco").addClass("visible");
	  } else {
	    $(window).on("load scroll", function () {
	      var tgPos = $("#maincontents").offset().top - 100;
	      var scrollHeight = $(this).scrollTop();
	
	      if (scrollHeight > tgPos) {
	        $(".st-Sidedeco").addClass("visible");
	      } else {
	        $(".st-Sidedeco").removeClass("visible");
	      }
	    });
	  }
	}; // ------------------------------------------------------------------------
	// fallingRose
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleSidedeco = toggleSidedeco;
	
	var fallingRose = function fallingRose() {
	  var ua = navigator.userAgent;
	
	  if (ua.indexOf('Trident') !== -1) {} else {
	    var sizemin = 0;
	    var sizemax = 0;
	    var countbase = 0;
	
	    if (matchMedia('(max-width: 768px)').matches) {
	      sizemin = 60 * (window.innerWidth / 1920);
	      sizemax = 140 * (window.innerWidth / 1920);
	      countbase = 500;
	    } else {
	      sizemin = 20;
	      sizemax = 40;
	      countbase = 60;
	    }
	
	    $(window).on("load", function () {
	      party.registerShape('rose', '<path fill="#db0010" d="M24.87 3c-4.06 2.54-13.18 2-17.74 8.11S-1.49 25.86.54 36.5s3 14.2 5.07 14.71c4.56-2 1.52-3.55 4.56-2s3 3.55 3.55 5.07 2 2 4 1.52 2-1 4.06-1 5.58 1.52 7.6 0 7.61-.5 11.16-10.64 7.09-21.3.5-30.93S33.49 2 32.47 0c-3.04 1-3.54.51-7.6 3z"/>');
	      party.element(document.getElementById("fallingrose-container"), {
	        size: party.minmax(sizemin, sizemax),
	        angle: 180,
	        count: party.variation(countbase * (window.innerWidth / 1980), 0.3),
	        spread: 360,
	        gravity: false,
	        velocity: party.minmax(150, 400),
	        angularVelocity: party.minmax(2, 4),
	        color: ["#cc000c"],
	        shape: "rose"
	      });
	    });
	    $('.idx-Mainvisual').on('click', function (e) {
	      var percent = window.innerHeight / $("#party-js-canvas").outerHeight();
	      var cursorX = window.innerWidth - e.pageX;
	      var cursorY = ($("#party-js-canvas").outerHeight() - e.pageY) * percent;
	      party.registerShape('rose', '<path fill="#db0010" d="M24.87 3c-4.06 2.54-13.18 2-17.74 8.11S-1.49 25.86.54 36.5s3 14.2 5.07 14.71c4.56-2 1.52-3.55 4.56-2s3 3.55 3.55 5.07 2 2 4 1.52 2-1 4.06-1 5.58 1.52 7.6 0 7.61-.5 11.16-10.64 7.09-21.3.5-30.93S33.49 2 32.47 0c-3.04 1-3.54.51-7.6 3z"/>');
	      party.position(cursorX, cursorY, {
	        size: party.minmax(sizemin, sizemax),
	        count: 5,
	        spread: 360,
	        gravity: false,
	        velocity: party.minmax(150, 400),
	        angularVelocity: party.minmax(2, 4),
	        color: ["#cc000c"],
	        shape: "rose"
	      });
	    });
	  }
	}; // ------------------------------------------------------------------------
	// randomChara
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.fallingRose = fallingRose;
	
	var randomChara = function randomChara() {
	  var names = ['ayato', 'kanato', 'laito', 'shu', 'reiji', 'subaru', 'ruki', 'kou', 'yuma', 'azusa', 'carla', 'shin', 'kino'];
	  var words = ['トーゼン祝うだろ？<br>オレ様にオマエの想い<br>聞かせろよ！', '僕との思い出は<br>君だけのものです。<br>確かめたいからこっそり<br>教えてください。', 'ビッチちゃんとお祝い<br>できて嬉しいなぁ♥<br>せっかくだからボクとの<br>特別な思い出教えて？', '祝い事とか<br>面倒くさいけど……<br>あんたとの思い出が<br>聞けるなら考えてやる', '記念すべき日ですね。<br>改めて貴女の想いを<br>聞かせてもらえますか？', 'オレといた時間、<br>お前は何を想って<br>いたんだ？その口で<br>ちゃんと教えろ', '俺と積み上げてきた<br>歳月、忘れたとは<br>言わせない。思い返して、<br>話してくれるな？', 'エム猫ちゃんと<br>お祝いだ！この機会に<br>思い出を振り返って<br>みるのはどうかな？', '喧嘩もしたが、<br>今日までオマエと一緒に<br>いられてよかったぜ。<br>オマエはどう思う？', 'イブと一緒にいた時間……<br>思い返したらもっとイブを<br>好きになっちゃった<br>……ねぇ、今までのこと<br class="sp_b">話そうよ', '貴様と歩んだ道を<br>もう一度思い出すのも<br>一興。当然付き合って<br>くれるな？', '今までの思い出を<br>語ってみなよ。<br>少しは祝いたくなる<br>かもね', 'お祝いだし、<br>今日は一緒に居ようよ<br>思い出なんかを<br>語っちゃったりしてさ'];
	  var lth = names.length;
	  $(window).on("load", function () {
	    $('.idx-Share_Inner').each(function (index, element) {
	      var ran = Math.floor(Math.random() * lth); //- let ran = 0;
	      //- console.log(names[ran]);
	
	      $(element).find(".chara").addClass(names[ran]);
	      $(element).find(".wrapper").addClass(names[ran]);
	      $(element).find(".words").append(words[ran]);
	    });
	  });
	};
	
	exports.randomChara = randomChara;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js